/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

function handleInitialAdjustments({
  questionnaire,
  setQuestionnaire,
  setFieldValue,
  personData,
  parentPersonData,
  addingUser,
  user,
  isEditing,
  isBrokerRelationship,
  borrowerCcgIdOperation
}) {
  try {
    const isCPF = questionnaire.find(q => q.idQuestion === 1885)?.answer?.length === 11;

    questionnaire = questionnaire.map(question => {
      if (question.idQuestion === 1885) {
        if (addingUser) question.behaviorObject.searchQueryId = null;

        questionnaire = questionnaire.map(qst => {
          if (qst.idQuestion === 1886) {
            qst.behaviorObject.isRequired = isCPF;
          }

          if ([1886, 1887].includes(qst.idQuestion)) {
            qst.disabled = !isCPF || isEditing;
            qst.behaviorObject.isReadOnly = !isCPF || isEditing;
          }

          return qst;
        });
      }

      if (personData && !addingUser) {
        if (question.idQuestion === 1885) {
          question.answer = personData?.legalPersonId;
          if (!question.answer) question.behaviorObject.isRequired = false;
          setFieldValue && setFieldValue(question.key, personData?.legalPersonId)
        }

        if (question.idQuestion === 1886) {
          question.answer = personData?.firstName;
          setFieldValue && setFieldValue(question.key, personData?.firstName)
        }

        if (question.idQuestion === 1887) {
          question.answer = personData?.lastName;
          setFieldValue && setFieldValue(question.key, personData?.lastName)
        }

        if (question.idQuestion === 1888) {
          const selectedOption = question.answerOptions.find(v => v.idAnswerOption === (personData?.idDomain === 35 ? 7551 : 7550));

          if (selectedOption) {
            const result = {
              idAnswerOption: selectedOption?.idAnswerOption,
              dsAnswerOption: selectedOption?.dsAnswerOption,
              resultValue: selectedOption?.behaviorObject?.resultValue || null
            };

            question.answer = selectedOption?.dsAnswerOption;
            question.answerJson = selectedOption.answerJson;
            question.idAnswerOption = selectedOption?.idAnswerOption;
            setFieldValue && setFieldValue(question.key, result);
          }
        }

        if (question.idQuestion === 1889) {
          const selectedOption = question.answerOptions.find(v => v.idAnswerOption === (personData?.idDomain === 34 ? 7554 : personData?.hierarchy === "Holding" ? 7552 : 7553));

          if (selectedOption) {
            const result = {
              idAnswerOption: selectedOption?.idAnswerOption,
              dsAnswerOption: selectedOption?.dsAnswerOption,
              resultValue: selectedOption?.behaviorObject?.resultValue || null
            };

            question.answer = selectedOption?.dsAnswerOption;
            question.answerJson = selectedOption.answerJson;
            question.idAnswerOption = selectedOption?.idAnswerOption;
            setFieldValue && setFieldValue(question.key, result);
          }
        }

        if (question.idQuestion === 1890) {
          question.behaviorObject.isRequired = personData?.idDomain === 34 || personData?.hierarchy !== "Holding";

          let questionAnswer = '';
          let questionValue = '';

          if (personData?.legalEntity) {
            questionValue = `${personData?.legalEntity?.legalPersonId} - ${personData?.legalEntity?.lastName}`;
            questionAnswer = JSON.stringify({ id: personData?.legalEntity?.idPerson, value: questionValue })

          } else if (personData?.parentCompany) {
            questionValue = `${personData?.parentCompany?.legalPersonId} - ${personData?.parentCompany?.lastName}`;
            questionAnswer = JSON.stringify({ id: personData?.parentCompany?.idPerson, value: questionValue })
          }

          question.answer = questionValue;
          question.answerJson = questionAnswer;
          setFieldValue && setFieldValue(question.key, questionValue)
        }

        if ([2197, 2194].includes(question.idQuestion)) {
          let filial = personData.personRelationships[290]?.find(filial => filial.relationshipContent.hasOwnProperty('insurerBrokerId'));

          const brokerRelationship = personData.personRelationships["290"] && personData.personRelationships["290"].some((relation) => relation.idPersonHead === personData.idPerson);
          question.visibleQuestion = brokerRelationship && personData.idDomain !== 34;
          question.behaviorObject.isRequired = brokerRelationship && personData.idDomain !== 34;

          if (filial) {
            const filialMetadata = JSON.parse(filial?.personTailMetadata || '{}');
            const insurerLegalEntityId = filialMetadata?.insurerLegalEntityId || null;
            if(question.idQuestion === 2194) {
              const filialQuestionAnswer = `${filial.personTailLastName}${insurerLegalEntityId ? ` - ${insurerLegalEntityId}` : ''}`;
              question.answerJson = JSON.stringify({ value: filialQuestionAnswer, id: filial.idPersonTail });
              question.answer = filialQuestionAnswer;
              setFieldValue && setFieldValue(question.key,filialQuestionAnswer);
            } else {
              question.answer = filial.relationshipContent?.insurerBrokerId
              setFieldValue && setFieldValue(question.key, question.answer);
            }
          }
        }
        

        if (question.idQuestion === 1891) {
          let selectedOption = null

          const headRelationships = personData.personRelationships || [];
          const brokerRelationship = headRelationships["290"] && headRelationships["290"].some((relation) => relation.idPersonHead === personData.idPerson);

          const tailRelationships = personData.personRelationshipsTail || [];
          const agencyRelationship = tailRelationships["290"] && tailRelationships["290"].some((relation) => relation.idPersonTail === personData.idPerson);

          if (agencyRelationship) {
            selectedOption = question.answerOptions.find(v => v.idAnswerOption === 7555);
          } else if (brokerRelationship) {
            selectedOption = question.answerOptions.find(v => v.idAnswerOption === 7556);
          } else if (borrowerCcgIdOperation) {
            selectedOption = question.answerOptions.find(v => v.idAnswerOption === 7559);
          } else {
            selectedOption = question.answerOptions.find(v => v.idAnswerOption === 7557);
          }

          if (selectedOption) {
            const result = {
              idAnswerOption: selectedOption?.idAnswerOption,
              dsAnswerOption: selectedOption?.dsAnswerOption,
              resultValue: selectedOption?.behaviorObject?.resultValue || null
            };

            question.answer = selectedOption?.dsAnswerOption;
            question.answerJson = selectedOption.answerJson;
            question.idAnswerOption = selectedOption?.idAnswerOption;
            setFieldValue && setFieldValue(question.key, result);
          }
        }

        if (question.idQuestion === 1892) {
          question.answer = personData?.susepNumber;
          setFieldValue && setFieldValue(question.key, personData?.susepNumber)
          if (!personData?.susepNumber?.length) question.behaviorObject.isRequired = false;
        }
      }

      if (addingUser && personData && parentPersonData) {
        if (isBrokerRelationship) {
          if (question.idQuestion === 1885) {
            question.behaviorObject.isRequired = false;
            question.behaviorObject.allowUserWithoutLegalId = true;
          }

          if ([1886, 1887].includes(question.idQuestion)) {
            question.disabled = false;
            question.behaviorObject.isReadOnly = false;
          }
        }

        if (question.idQuestion === 1888) {
          const selectedOption = question.answerOptions.find(v => v.idAnswerOption === 7550);

          const result = {
            idAnswerOption: selectedOption?.idAnswerOption,
            dsAnswerOption: selectedOption?.dsAnswerOption,
            resultValue: selectedOption?.behaviorObject?.resultValue || null
          };

          question.answer = selectedOption?.dsAnswerOption;
          question.answerJson = selectedOption.answerJson;
          question.idAnswerOption = selectedOption?.idAnswerOption;
          question.disabled = true;
          question.behaviorObject.isReadOnly = true;
          setFieldValue && setFieldValue(question.key, result);
        }

        if (question.idQuestion === 1889) {
          const selectedOption = question.answerOptions.find(v => v.idAnswerOption === 7554);

          const result = {
            idAnswerOption: selectedOption?.idAnswerOption,
            dsAnswerOption: selectedOption?.dsAnswerOption,
            resultValue: selectedOption?.behaviorObject?.resultValue || null
          };

          question.answer = selectedOption?.dsAnswerOption;
          question.answerJson = selectedOption.answerJson;
          question.idAnswerOption = selectedOption?.idAnswerOption;
          question.disabled = true;
          question.behaviorObject.isReadOnly = true;
          setFieldValue && setFieldValue(question.key, result);
        }

        if (question.idQuestion === 1891) {
          const selectedOption = question.answerOptions.find(v => v.idAnswerOption === 7557);

          const result = {
            idAnswerOption: selectedOption?.idAnswerOption,
            dsAnswerOption: selectedOption?.dsAnswerOption,
            resultValue: selectedOption?.behaviorObject?.resultValue || null
          };

          question.answer = selectedOption?.dsAnswerOption;
          question.answerJson = selectedOption.answerJson;
          question.idAnswerOption = selectedOption?.idAnswerOption;
          question.disabled = true;
          question.behaviorObject.isReadOnly = true;
          setFieldValue && setFieldValue(question.key, result);
        }

        if (question.idQuestion === 1892) question.behaviorObject.isRequired = false;

        if ([1902, 1903].includes(question.idQuestion)) {
          const idAnswerOption = question.idQuestion === 1902 ? 7560 : 7562;
          const selectedOption = question.answerOptions.find(v => v.idAnswerOption === idAnswerOption);

          const result = {
            idAnswerOption: selectedOption?.idAnswerOption,
            dsAnswerOption: selectedOption?.dsAnswerOption,
            resultValue: selectedOption?.behaviorObject?.resultValue || null
          };

          question.answer = selectedOption?.dsAnswerOption;
          question.answerJson = selectedOption?.answerJson;
          question.idAnswerOption = selectedOption?.idAnswerOption;
          question.disabled = true;
          question.behaviorObject.isReadOnly = true;
          setFieldValue && setFieldValue(question.key, result);
        }

        if ([1893, 1895, 1896, 1897, 1898, 1899, 1900, 1901, 1904, 1982].includes(question.idQuestion)) {
          question.visibleQuestion = false;
        }

        if (personData.idDomain === 34) {
          if (question.idQuestion === 1885) {
            question.answer = personData.legalPersonId;
            question.answerJson = personData.legalPersonId;
            question.behaviorObject.disabled = true;
            question.behaviorObject.isReadOnly = true;
            setFieldValue && setFieldValue(question.key, personData.legalPersonId)
          }

          if (question.idQuestion === 1886) {
            question.answer = personData.firstName;
            question.answerJson = personData.firstName;
            question.behaviorObject.disabled = true;
            question.behaviorObject.isReadOnly = true;
            setFieldValue && setFieldValue(question.key, personData.firstName)
          }

          if (question.idQuestion === 1887) {
            question.answer = personData.lastName;
            question.answerJson = personData.lastName;
            question.behaviorObject.disabled = true;
            question.behaviorObject.isReadOnly = true;
            setFieldValue && setFieldValue(question.key, personData.lastName)
          }

          if (question.idQuestion === 1890) {
            const questionValue = `${personData?.legalEntity?.legalPersonId} - ${personData?.legalEntity?.lastName}`
            const questionAnswer = JSON.stringify({ id: personData?.legalEntity?.idPerson, value: questionValue })

            question.answer = questionValue;
            question.answerJson = questionAnswer;
            question.behaviorObject.disabled = true;
            question.behaviorObject.isReadOnly = true;
            setFieldValue && setFieldValue(question.key, questionValue)
          }

          if (question.idQuestion === 1892) {
            const questionAnswer = personData.susepNumber

            question.answer = questionAnswer;
            question.answerJson = questionAnswer;
            question.behaviorObject.disabled = true;
            question.behaviorObject.isReadOnly = true;
            setFieldValue && setFieldValue(question.key, questionAnswer)
          }

          if (question.idQuestion === 1894) {
            const questionAnswer = personData?.contacts?.find(contact => contact.isMainContact === 1 && contact.idDomain === 32)?.description;

            if (questionAnswer && Boolean(question.visibleQuestion)) {
              question.answer = questionAnswer;
              question.answerJson = questionAnswer;
              question.behaviorObject.disabled = true;
              question.behaviorObject.isReadOnly = true;
              setFieldValue && setFieldValue(question.key, questionAnswer)
            }
          }
        } else {
          if (question.idQuestion === 1890) {
            const questionAnswer = JSON.stringify({ id: parentPersonData.idPerson, value: `${parentPersonData.legalPersonId} - ${parentPersonData?.lastName}` })

            question.answer = `${parentPersonData.legalPersonId} - ${parentPersonData?.lastName}`;
            question.answerJson = questionAnswer;
            question.behaviorObject.disabled = true;
            question.behaviorObject.isReadOnly = true;
            setFieldValue && setFieldValue(question.key, question.answer)
          }
        }
      }

      return question;
    });

    if (isBrokerRelationship) setQuestionnaire(questionnaire);

    return questionnaire;
  } catch (e) {
    console.log("PERSON - handleInitialAdjustments error", e)
  }
}

function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  setShowProductPlansSection,
  setProductPlansGroup,
  setShowBorrowerInfoSection,
  addingUser,
  editContact,
  setSelectedContact,
  mc,
  setIsUsernameAvailable,
}) {
  try {
    let saveFilteredQuestionnaire = false;

    if (question.idQuestion === 1885) {
      saveFilteredQuestionnaire = true;

      question.answer = value;
      setFieldValue && setFieldValue(question.key, value);

      const isCPF = value.length === 11;

      if (addingUser && value.length > 11) {
        mc.error('Não é permitido cadastrar usuário para uma parte do tipo Pessoa Jurídica. Favor informar um CPF válido.');
      }

      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if (qst.idQuestion === 1886) {
          qst.disabled = !isCPF;
          qst.behaviorObject.isReadOnly = !isCPF;
          qst.behaviorObject.isRequired = isCPF;
          qst.answer = null;
          setFieldValue && setFieldValue(qst.key, '');
        }

        if (qst.idQuestion === 1887) {
          qst.disabled = !isCPF;
          qst.behaviorObject.isReadOnly = !isCPF;
          qst.answer = null;
          setFieldValue && setFieldValue(qst.key, '');
        }

        if (qst.idQuestion === 1888) {
          if (addingUser) return qst;
          let selectedOption = null

          if (value.length === 11) {
            selectedOption = qst.answerOptions.find(v => v.idAnswerOption === 7550);
          }

          if (value.length === 14) {
            selectedOption = qst.answerOptions.find(v => v.idAnswerOption === 7551);
          }

          if (selectedOption) {
            const result = {
              idAnswerOption: selectedOption?.idAnswerOption,
              dsAnswerOption: selectedOption?.dsAnswerOption,
              resultValue: selectedOption?.behaviorObject?.resultValue || null
            };

            qst.answer = selectedOption?.dsAnswerOption;
            qst.answerJson = selectedOption.answerJson;
            qst.idAnswerOption = selectedOption?.idAnswerOption;
            setFieldValue && setFieldValue(qst.key, result);
          }
        }

        if (qst.idQuestion === 1889) {
          if (addingUser) return qst;
          qst.answerOptions = qst.answerOptions.map(option => {
            if ([7553, 7554].includes(option.idAnswerOption)) {
              questionnaireUpdated = questionnaireUpdated.map(q => {
                if (q.idQuestion === 1890) {
                  q.behaviorObject.isRequired = true;
                }

                return q;
              });
            }

            if (option.idAnswerOption === 7554) {
              return {
                ...option,
                behaviorObject: {
                  ...option.behaviorObject,
                  isReadOnly: !isCPF
                }
              };
            }

            return option;
          })

          const individualAnswerOption = qst.answerOptions.find(v => v.idAnswerOption === 7554);

          const result = {
            idAnswerOption: isCPF ? individualAnswerOption?.idAnswerOption : null,
            dsAnswerOption: isCPF ? individualAnswerOption?.dsAnswerOption : null,
            resultValue: isCPF ? individualAnswerOption?.behaviorObject?.resultValue || null : null
          };

          qst.answer = isCPF ? individualAnswerOption?.dsAnswerOption : "";
          qst.answerJson = isCPF ? individualAnswerOption.answerJson : "";
          qst.idAnswerOption = isCPF ? individualAnswerOption?.idAnswerOption : null;
          qst.disabled = isCPF;
          qst.behaviorObject.isReadOnly = isCPF;
          setFieldValue && setFieldValue(qst.key, result);
        }

        if (qst.idQuestion === 1890) {
          qst.behaviorObject.isRequired = isCPF;
        }

        if (qst.idQuestion === 1891) {
          if (addingUser) return qst;
          qst.answerOptions = qst.answerOptions.map(option => {
            if (option.idAnswerOption === 7557) {
              return {
                ...option,
                behaviorObject: {
                  ...option.behaviorObject,
                  isReadOnly: !isCPF
                }
              };
            }

            return option;
          })

          const individualAnswerOption = qst.answerOptions.find(v => v.idAnswerOption === 7557);

          const result = {
            idAnswerOption: isCPF ? individualAnswerOption?.idAnswerOption : null,
            dsAnswerOption: isCPF ? individualAnswerOption?.dsAnswerOption : "",
            resultValue: isCPF ? individualAnswerOption?.behaviorObject?.resultValue || null : null
          };

          qst.answer = isCPF ? individualAnswerOption?.dsAnswerOption : "";
          qst.answerJson = isCPF ? individualAnswerOption.answerJson : "";
          qst.idAnswerOption = isCPF ? individualAnswerOption?.idAnswerOption : null;
          qst.disabled = isCPF;
          qst.behaviorObject.isReadOnly = isCPF;
          setFieldValue && setFieldValue(qst.key, result);
        }

        if (qst.idQuestion === 1892) {
          qst.behaviorObject.isRequired = !isCPF;
        }

        return qst;
      });
    }

    if ([1886, 1887].includes(question.idQuestion)) {
      question.answer = value;
      setFieldValue && setFieldValue(question.key, value)
    }

    if (question.idQuestion === 1889) {
      questionnaireUpdated = questionnaireUpdated.map(q => {
        if (q.idQuestion === 1890) {
          q.behaviorObject.isRequired = value.idAnswerOption === 7553;
          q.behaviorObject.isReadOnly = value.idAnswerOption === 7552;

          if (value.idAnswerOption === 7552) {
            q.answer = '';
            q.answerJson = '';
            setFieldValue && setFieldValue(q.key, '')
          }
        }

        return q;
      });
    }
    if (question.idQuestion === 1891) {
      if (value.idAnswerOption === 7555 || value.idAnswerOption === 7556) {
        setProductPlansGroup((prev) => {
          return prev.map((group) => {
            return group.map((groupQuestion) => {
              if (groupQuestion.idQuestion === 1958) {
                groupQuestion.visibleQuestion = value.idAnswerOption === 7556;
              }

              if (groupQuestion.idQuestion === 1959) {
                groupQuestion.visibleQuestion = value.idAnswerOption === 7556;
              }

              if (groupQuestion.idQuestion === 1960) {
                groupQuestion.visibleQuestion = value.idAnswerOption === 7555;
              }

              return groupQuestion;
            });
          })
        });

        setShowProductPlansSection(true);
      } else {
        setShowProductPlansSection(false);
      }

      const isVisible = value.idAnswerOption === 7556;

      questionnaireUpdated = questionnaireUpdated.map(q => {
        if ([2197, 2194].includes(q.idQuestion)) q.visibleQuestion = isVisible;
        return q;
      });
      
      questionnaireUpdated = questionnaireUpdated.map(q => {
        if (q.idQuestion === 1892) {
          q.behaviorObject.isRequired = value.idAnswerOption === 7556;
        }
        return q;
      });

      if (value.idAnswerOption === 7559) {
        setShowBorrowerInfoSection(true);
      } else {
        setShowBorrowerInfoSection(false);
      }
    }

    if (question.idQuestion === 1894) {
      setIsUsernameAvailable(false);
    }

    if (question.idQuestion == 1897) {
      saveFilteredQuestionnaire = true;
      setFieldValue && setFieldValue(question.key, value);
    }

    // Controla a visibilidade das questões conforme o tipo de contato selecionado
    const questionMappings = {
      7562: [1894, 1902],
      7563: [1895, 1896, 1897, 1898, 1899, 1900, 1901, 1902, 1982],
      7564: [1893, 1902],
      7565: [1904, 1902],
      7566: [1904, 1902],
    };

    if (question.idQuestion === 1903) {
      const descriptionQuestion = questionnaireUpdated.find(q => q.idQuestion === 1904);
      descriptionQuestion.behaviorObject.isRequired = [7565, 7566].includes(value.idAnswerOption);

      const visibleQuestions = questionMappings[value.idAnswerOption];

      if (visibleQuestions) {
        questionnaireUpdated = questionnaireUpdated.map(qst => {
          Object.values(questionMappings).flat().forEach(id => {
            if (qst.idQuestion === id) {
              qst.visibleQuestion = false;
            }
          });

          if (visibleQuestions.includes(qst.idQuestion)) qst.visibleQuestion = true;

          return qst;
        });
      }
    }

    if (editContact) {
      if ([1893, 1894, 1904].includes(question.idQuestion)) {
        setSelectedContact((prev) => {
          return {
            ...prev,
            contactDescription: value,
          }
        });
      }

      const questionAddressMappings = {
        1895: 'zipCode',
        1896: 'streetName',
        1897: 'doorNumber',
        1898: 'complementary',
        1899: 'district',
        1900: 'city',
        1901: 'state',
      };

      if ([1895, 1896, 1897, 1898, 1899, 1900, 1901].includes(question.idQuestion)) {
        setSelectedContact((prev) => {
          const keyToUpdate = questionAddressMappings[question.idQuestion];
          return {
            ...prev,
            address: {
              ...prev.address,
              ...(keyToUpdate ? { [keyToUpdate]: value } : {}),
            },
          };
        });
      }

      if (question.idQuestion === 1902) {
        setSelectedContact((prev) => {
          return {
            ...prev,
            mainContact: value.idAnswerOption === 7560,
          }
        });
      }

      if (question.idQuestion === 1982) {
        setSelectedContact((prev) => {
          return {
            ...prev,
            address: {
              ...prev.address,
              postmailAddress: value.idAnswerOption === 7629,
            },
          }
        });
      }
    }

    if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
  } catch (e) {
    console.log("PERSON - handleQuestionChange error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
  idPerson,
}) {
  try {
    questionnaire = questionnaire.map(question => {
      if (rootQuestion.idQuestion === 1885 && 
        [1889].includes(question.idQuestion) && !idPerson) {
        question.answer = '';
        setFieldValue && setFieldValue(question.key, '');
      }

      if (rootQuestion.idQuestion === 1885 && 
        [1891].includes(question.idQuestion) && !idPerson) {
        question.answer = '';
        question.idAnswerOption = null;
        setFieldValue && setFieldValue(question.key, '');
      }

      if (rootQuestion.idQuestion === 1885 && question.idQuestion === 1885) {
        setFieldValue && setFieldValue(question.key, data.ni);
        question.answer = data.ni;
      }

      if (rootQuestion.idQuestion === 1885 && question.idQuestion === 1886) {
        setFieldValue && setFieldValue(question.key, data.nomeFantasia);
        question.answer = data.nomeFantasia;
      }

      if (rootQuestion.idQuestion === 1885 && question.idQuestion === 1887) {
        setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
        question.answer = data.nomeEmpresarial;
      }

      if (rootQuestion.idQuestion === 1885 && question.idQuestion === 1894) {
        setFieldValue && setFieldValue(question.key, data.correioEletronico);
        question.answer = data.correioEletronico;
      }

      if (rootQuestion.idQuestion === 1885 && question.idQuestion === 1893 && data?.telefones?.length) {
        question.answer = data?.telefones[0].ddd + data.telefones[0].numero;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1885 && question.idQuestion === 1895 && data?.endereco) {
        question.answer = data.endereco.cep;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1885 && question.idQuestion === 1896 && data?.endereco) {
        question.answer = `${data?.endereco.tipoLogradouro} ${data?.endereco.logradouro}`;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1885 && question.idQuestion === 1897 && data?.endereco) {
        question.answer = data.endereco.numero;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1885 && question.idQuestion === 1898 && data?.endereco) {
        question.answer = data.endereco.complemento;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1885 && question.idQuestion === 1899 && data?.endereco) {
        question.answer = data.endereco.bairro;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1885 && question.idQuestion === 1900 && data?.endereco) {
        question.answer = data.endereco?.municipio?.descricao;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1885 && question.idQuestion === 1901 && data?.endereco) {
        question.answer = data.endereco.uf;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      // if (rootQuestion.idQuestion === 1885 && question.idQuestion === 1646 && data?.endereco?.pais) {
      //   question.answer = data.endereco.pais.descricao;
      //   setFieldValue && setFieldValue(question.key, question.answer)
      // }

      return question;
    });

    setQuestionnaire(questionnaire);

  } catch (e) {
    console.log('PERSON - handleRequestSerproCnpj error', e)
  }
};

export const handleSearchZipCode = async (rootQuestion, zipCodeData, questionnaire, setFilteredQuestionnaire, setFieldValue) => {
  try {
    questionnaire = questionnaire.map(question => {

      if (rootQuestion.idQuestion == 1895 && question.idQuestion === 1895) {
        zipCodeData.ZIP_CODE = `${zipCodeData.ZIP_CODE}`.padStart(8, '0');
        setFieldValue && setFieldValue(question.key, String(zipCodeData.ZIP_CODE));
        return ({ ...question, answer: String(zipCodeData.ZIP_CODE) });
      }

      if (rootQuestion.idQuestion == 1895 && question.idQuestion === 1896) {
        setFieldValue && setFieldValue(question.key, zipCodeData.LONG_STREET_NAME);
        return ({ ...question, answer: zipCodeData.LONG_STREET_NAME });
      }

      if (rootQuestion.idQuestion == 1895 && question.idQuestion === 1899) {
        zipCodeData.ZIP_CODE = `${zipCodeData.DISTRICT}`.padStart(8, '0');
        setFieldValue && setFieldValue(question.key, String(zipCodeData.DISTRICT));
        return ({ ...question, answer: String(zipCodeData.DISTRICT) });
      }

      if (rootQuestion.idQuestion == 1895 && question.idQuestion === 1900) {
        setFieldValue && setFieldValue(question.key, zipCodeData.CITY);
        return ({ ...question, answer: zipCodeData.CITY });
      }

      if (rootQuestion.idQuestion == 1895 && question.idQuestion === 1901) {
        setFieldValue && setFieldValue(question.key, zipCodeData.STATE);
        return ({ ...question, answer: zipCodeData.STATE });
      }

      return question;
    })

    setFilteredQuestionnaire(questionnaire);
  } catch (error) {
    console.log('handleSearchZipCode error', error)
  }
};

async function handleContactFields({
  questionnaire,
  setFieldValue,
}) {
  try {
    questionnaire?.forEach(question => {
      if ([1893, 1894, 1895, 1896, 1897, 1898, 1899, 1900, 1901, 1902, 1903, 1904, 1982].includes(question.idQuestion)) {
        if (question.hasOwnProperty('answer')) question.answer = null;
        if (question.hasOwnProperty('answerJson')) question.answerJson = null;
        if (question.hasOwnProperty('idAnswerOption')) question.idAnswerOption = null;
        question.behaviorObject.isReadOnly = false;
        setFieldValue && setFieldValue(question.key, null);
      }
    });
  } catch (e) {
    console.log("PERSON - handleClearContactFields error", e);
  }
}

async function handleAddContact({
  questionnaire,
}) {
  try {
    questionnaire = questionnaire.map(qst => {
      if ([1893, 1894, 1895, 1896, 1897, 1898, 1899, 1900, 1901, 1902, 1904, 1982].includes(qst.idQuestion)) {
        qst.visibleQuestion = false;
      }

      return qst;
    });

  } catch (e) {
    console.log("PERSON - handleAddContact error", e);
  }
}

async function handleEditContact({
  questionnaire,
  setQuestionnaire,
  setFieldValue,
  listItem,
  hasRelationship
}) {
  try {
    const questionMapping = {
      7562: [1894],
      7563: [1895, 1896, 1897, 1898, 1899, 1900, 1901, 1982],
      7564: [1893],
      7565: [1904],
      7566: [1904],
    };

    const contactMapping = {
      30: 7563, //Address
      31: 7564, //Phone
      32: 7562, //E-mail
      33: 7566, //Website
      282: 7565, //Focal Point
    };

    const domainQuestionMap = {
      31: 1893,
      32: 1894,
      33: 1904,
      282: 1904
    };

    questionnaire = questionnaire.map(qst => {
      if (listItem.idDomain === 30) {
        if (qst.idQuestion === 1895) {
          qst.answer = listItem.address.zipCode;
          qst.behaviorObject.isReadOnly = !hasRelationship;
          setFieldValue && setFieldValue(qst.key, listItem.address.zipCode);
        }

        if (qst.idQuestion === 1896) {
          qst.answer = listItem.address.streetName;
          qst.behaviorObject.isReadOnly = !hasRelationship;
          setFieldValue && setFieldValue(qst.key, listItem.address.streetName);
        }

        if (qst.idQuestion === 1897) {
          qst.answer = listItem.address.doorNumber;
          qst.behaviorObject.isReadOnly = !hasRelationship;
          setFieldValue && setFieldValue(qst.key, listItem.address.doorNumber);
        }

        if (qst.idQuestion === 1898) {
          qst.answer = listItem.address.complementary;
          qst.behaviorObject.isReadOnly = !hasRelationship;
          setFieldValue && setFieldValue(qst.key, listItem.address.complementary);
        }

        if (qst.idQuestion === 1899) {
          qst.answer = listItem.address.district;
          qst.behaviorObject.isReadOnly = !hasRelationship;
          setFieldValue && setFieldValue(qst.key, listItem.address.district);
        }

        if (qst.idQuestion === 1900) {
          qst.answer = listItem.address.city;
          qst.behaviorObject.isReadOnly = !hasRelationship;
          setFieldValue && setFieldValue(qst.key, listItem.address.city);
        }

        if (qst.idQuestion === 1901) {
          qst.answer = listItem.address.state;
          qst.behaviorObject.isReadOnly = !hasRelationship;
          setFieldValue && setFieldValue(qst.key, listItem.address.state);
        }

        if (qst.idQuestion === 1982) {
          const answerOptionId = listItem.address.postmailAddress ? 7629 : 7628;
          const selectedOption = qst.answerOptions.find(v => v.idAnswerOption === answerOptionId);

          if (selectedOption) {
            const result = {
              idAnswerOption: selectedOption.idAnswerOption,
              dsAnswerOption: selectedOption.dsAnswerOption,
              resultValue: selectedOption.behaviorObject?.resultValue || null
            };

            qst.answer = selectedOption.dsAnswerOption;
            qst.answerJson = selectedOption.answerJson;
            qst.idAnswerOption = selectedOption.idAnswerOption;
            qst.behaviorObject.isReadOnly = !hasRelationship;

            setFieldValue && setFieldValue(qst.key, result);
          }
        }
      }

      if (domainQuestionMap[listItem.idDomain] === qst.idQuestion) {
        qst.answer = listItem.contactDescription;
        setFieldValue && setFieldValue(qst.key, listItem.contactDescription);
      }

      if (qst.idQuestion === 1902) {
        const answerOptionId = listItem.mainContact ? 7560 : 7561;
        const selectedOption = qst.answerOptions.find(v => v.idAnswerOption === answerOptionId);

        if (selectedOption) {
          const result = {
            idAnswerOption: selectedOption.idAnswerOption,
            dsAnswerOption: selectedOption.dsAnswerOption,
            resultValue: selectedOption.behaviorObject?.resultValue || null
          };

          qst.answer = selectedOption.dsAnswerOption;
          qst.answerJson = selectedOption.answerJson;
          qst.idAnswerOption = selectedOption.idAnswerOption;
          qst.visibleQuestion = true;
          qst.behaviorObject.isReadOnly = listItem.idDomain === 30 && !hasRelationship;

          setFieldValue && setFieldValue(qst.key, result);
        }
      }

      if (qst.idQuestion === 1903) {
        const selectedOption = qst.answerOptions.find(v => v.idAnswerOption === contactMapping[listItem.idDomain]);

        if (selectedOption) {
          const result = {
            idAnswerOption: selectedOption.idAnswerOption,
            dsAnswerOption: selectedOption.dsAnswerOption,
            resultValue: selectedOption.behaviorObject?.resultValue || null
          };

          qst.answer = selectedOption.dsAnswerOption;
          qst.answerJson = selectedOption.answerJson;
          qst.idAnswerOption = selectedOption.idAnswerOption;
          qst.visibleQuestion = true;
          qst.behaviorObject.isReadOnly = true;

          // Controla a visibilidade das questões conforme o tipo de contato selecionado para edição
          const visibleQuestions = questionMapping[selectedOption.idAnswerOption];

          if (visibleQuestions) {
            questionnaire = questionnaire.map(q => {
              Object.values(questionMapping).flat().forEach(id => {
                if (q.idQuestion === id) q.visibleQuestion = false;
              });

              if (visibleQuestions.includes(q.idQuestion)) q.visibleQuestion = true;
            });
          }

          setFieldValue && setFieldValue(qst.key, result);
        }
      }

      return qst;
    });

    setQuestionnaire(questionnaire);
  } catch (e) {
    console.log("PERSON - handleContactAdjustments error", e);
  }
}

function handleCreateContact({
  answers,
  getDescription,
}) {
  try {
    const isMainContact = answers.find(item => item.idQuestion === 1902);

    const newContactInfo = answers?.reduce((acc, obj) => {
      if (obj.idQuestion === 1903 && obj.idAnswerOption === 7563) {
        acc.address = {
          zipCode: answers.find(item => item.idQuestion === 1895).answer,
          streetName: answers.find(item => item.idQuestion === 1896).answer,
          doorNumber: answers.find(item => item.idQuestion === 1897).answer,
          complementary: answers.find(item => item.idQuestion === 1898).answer,
          district: answers.find(item => item.idQuestion === 1899).answer,
          city: answers.find(item => item.idQuestion === 1900).answer,
          state: answers.find(item => item.idQuestion === 1901).answer,
          postmailAddress: 0,
          country: 'Brazil',
          idDomainType: 10,
          idDomain: 251,
        };
        acc.contactDescription = getDescription("DOMAINS", 841);
        acc.idDomain = 30;
        acc.mainContact = isMainContact.idAnswerOption === 7560;
      }

      // phone
      if (obj.idQuestion === 1903 && obj.idAnswerOption === 7564) {
        acc.contactDescription = answers?.find(item => item.idQuestion === 1893)?.answer;
        acc.idDomain = 31;
        acc.mainContact = isMainContact.idAnswerOption === 7560;
      }

      // e-mail
      if (obj.idQuestion === 1903 && obj.idAnswerOption === 7562) {
        acc.contactDescription = answers?.find(item => item.idQuestion === 1894)?.answer;
        acc.idDomain = 32;
        acc.mainContact = isMainContact.idAnswerOption === 7560;
      }

      // website
      if (obj.idQuestion === 1903 && obj.idAnswerOption === 7566) {
        acc.contactDescription = answers?.find(item => item.idQuestion === 1904)?.answer;
        acc.idDomain = 33;
        acc.mainContact = isMainContact.idAnswerOption === 7560;
      }

      // focal point
      if (obj.idQuestion === 1903 && obj.idAnswerOption === 7565) {
        acc.contactDescription = answers?.find(item => item.idQuestion === 1904)?.answer;
        acc.idDomain = 282;
        acc.mainContact = isMainContact.idAnswerOption === 7560;
      }

      return acc;
    }, {});

    return newContactInfo;
  } catch (e) {
    console.log("PERSON - handleCreateContact error", e);
  }
}

function handleExistingPerson({
  questionnaire,
  setQuestionnaire,
  setFieldValue,
  personData,
}) {
  try {
    questionnaire = questionnaire.map(question => {
      if (question.idQuestion === 1885) {
        question.answer = personData?.legalPersonId;
        setFieldValue && setFieldValue(question.key, personData?.legalPersonId)
      }

      // if (question.idQuestion === 1886) {
      //   setFieldValue && setFieldValue(question.key, personData?.personFirstName);
      //   question.answer = personData?.personFirstName;
      // }

      // if (question.idQuestion === 1887) {
      //   question.answer = personData?.personLastName;
      //   setFieldValue && setFieldValue(question.key, personData?.personLastName)
      // }
      
      if (question.idQuestion === 1892 && personData?.susepNumber) {
        question.answer = personData?.susepNumber;
        question.behaviorObject.isReadOnly = true;
        setFieldValue && setFieldValue(question.key, personData?.susepNumber)
      }

      if (question.idQuestion === 1890 && (personData?.idPersonParent || personData?.idPersonRoot)) {

        const id = personData?.idPersonParent ?? personData?.idPersonRoot
        const value = personData?.personParent?.personLastName || personData?.root?.personLastName || '';
        question.answer = `${id} - ${value}`;
        question.answerJson = JSON.stringify({ id, value });

        question.behaviorObject.isReadOnly = true;
        setFieldValue && setFieldValue(question.key, question.answer);
      }
      return question;
    });

    setQuestionnaire(questionnaire);
  }
  catch (e) {
    console.log("PERSON - handleExistingPerson error", e)
  }
}

async function handleQuestionAdjustments({
  questionnaire,
  accessGroups,
}) {
  try {
    const question1905 = questionnaire?.find(q => q.idQuestion === 1905);
    if (question1905) question1905.behaviorObject.isRequired = accessGroups?.length === 0;
  } catch (e) {
    console.log("PERSON - handlePersonType error", e)
  }
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleRequestSerproCnpj,
  handleSearchZipCode,
  handleEditContact,
  handleCreateContact,
  handleAddContact,
  handleExistingPerson,
  handleQuestionAdjustments,
  handleContactFields
}

export { events };